import { render, staticRenderFns } from "./Pessoas.vue?vue&type=template&id=f434723c"
import script from "./Pessoas.vue?vue&type=script&lang=js"
export * from "./Pessoas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports